"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var AvatarPlaceholder = function AvatarPlaceholder(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_avatar)"
  }, (0, _preact.h)("rect", {
    width: "40",
    height: "40",
    rx: "20",
    fill: "#E6E6E6"
  }), (0, _preact.h)("path", {
    d: "M14 16C14 12.6863 16.6863 10 20 10V10C23.3137 10 26 12.6863 26 16V18C26 21.3137 23.3137 24 20 24V24C16.6863 24 14 21.3137 14 18V16Z",
    fill: "#808080"
  }), (0, _preact.h)("rect", {
    x: "6",
    y: "26",
    width: "28",
    height: "40",
    rx: "10",
    fill: "#808080"
  })), (0, _preact.h)("rect", {
    x: "0.5",
    y: "0.5",
    width: "39",
    height: "39",
    rx: "19.5",
    stroke: "#5E5E5E",
    strokeOpacity: "0.2"
  }), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_avatar"
  }, (0, _preact.h)("rect", {
    width: "40",
    height: "40",
    rx: "20",
    fill: "white"
  }))));
};

var _default = AvatarPlaceholder;
exports.default = _default;